// Business Registration Constants

export const RESIDENT_STATUS = {
  RESIDENT: 'true',
  NON_RESIDENT: 'false',
};

export const BUSINESS_TYPES = [
  { value: 'retail', label: 'Retail' },
  { value: 'service', label: 'Service' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'others', label: 'Others' },
];

export const CLASSIFICATIONS = [
  { value: 'micro', label: 'Micro' },
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' },
];

export const BUSINESS_NATURES = [
  { value: 1, label: 'Retail Trade' },
  { value: 2, label: 'Service' },
  { value: 3, label: 'Manufacturing' },
  { value: 4, label: 'Wholesale Trade' },
  { value: 5, label: 'Agriculture' },
  { value: 6, label: 'Construction' },
  { value: 7, label: 'Transportation' },
  { value: 8, label: 'Food Services' },
  { value: 9, label: 'Real Estate' },
  { value: 10, label: 'Technology' },
  { value: 11, label: 'Education' },
  { value: 12, label: 'Healthcare' },
  { value: 13, label: 'Finance' },
  { value: 14, label: 'Entertainment' },
  { value: 15, label: 'Others' },
];

export const MIN_SEARCH_LENGTH = 2;
